/**
 * Calendar Module Routes (Expansão v2 / Épico E2 / Story E2.3.1).
 *
 * Permissão ``calendar:read`` JÁ está seedada no DB
 * (``app/db/seeds/calendar_permissions_seed.py`` — atribuída a
 * admin/gerente/operador). Backend gateia com
 * ``require_permissions(["calendar:read"])`` e ``RequirePermission`` no
 * frontend evita o request inútil pra users sem a permissão.
 */

import { lazy } from "react";

import { ModuleRoutes } from "../types";

const CalendarPage = lazy(() => import("@/pages/calendar/CalendarPage"));

export const calendarRoutes: ModuleRoutes = {
  moduleId: "calendar",
  basePath: "/calendar",
  routes: [
    {
      path: "/calendar",
      element: <CalendarPage />,
      permission: { resource: "calendar", action: "read" },
    },
  ],
};
